import React from "react";
import Layout from "../Layout/Layout";

const TicketOut = () => {
  return <Layout></Layout>;
};

export default TicketOut;
